module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('DrugInfo')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [(_vm.currentProgress === 'confirm') ? _c('ConfirmFlow', {
    attrs: {
      "confirmProgress": _vm.confirmProgress
    },
    on: {
      "confirmationFinish": _vm.getConfirmData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10437feb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecycleDrugFlow/MultiFlow.vue
// module id = 1388
// module chunks = 1